import $ from 'jquery'

function animate(divId, animation) {
  const div = $(divId)
  const clear = () => { div.slideUp() }
  switch (animation) {
    case 'remain-left':
      div.css({position: 'relative'})
      div.animate({left: '-=100%'}, 500)
      break
    case 'slide-left':
      div.css({position: 'relative'})
      div.animate({left: '-=100%'}, 500, clear)
      break
    case 'slide-right':
      div.css({position: 'relative'})
      div.animate({left: '+=100%'}, 500, clear)
      break
    case 'slide-up':
      div.slideUp()
      break
    default:
      // Placate the linter
  }
}

// Click all the "Archive" buttons, but include `?refresh=false` for all but the last one.
function archiveAll(selectorForCompleted) {
  const buttons = $(selectorForCompleted)
  for (let i = 0; i < buttons.length; i += 1) {
    if (i < buttons.length - 1) {
      buttons[i].name = 'refresh'
      buttons[i].value = 'false'
    }
    buttons[i].click()
  }
}

function closeBsModal() {
  // Attempt to close the modal properly
  $('.modal-dialog .close').click()

  // Clean up artifacts from any potential failure
  $('.modal').modal('hide')
  $('.modal-backdrop').remove()
  $('body').removeClass('modal-open')
}

function enableBsPopovers(container) {
  $('[data-toggle="popover"]').popover({
    container,
    html: true,
    placement: 'bottom',
    trigger: 'click focus hover',
  })
}

function enableReordering(containerId, reorderPath) {
  $(containerId).sortable({
    forcePlaceholderSize: true,
    handle: '.js-sorting-handle',
    items: '> turbo-frame',
    placeholder: 'sortable-placeholder',
    update: (event) => {
      $.ajax({
        data: $(event.target).sortable('serialize'),
        type: 'PUT',
        url: reorderPath,
      })
    },
  })
}

function refreshTurboFrame(frameID, src = null) {
  const turboFrame = document.getElementById(frameID)
  if (turboFrame) {
    if (src)
      turboFrame.src = src
    turboFrame.reload()
  }
}

function updatePersonDropdown(event, fieldName = 'role_id') {
  setTimeout(() => {
    const form = $(event.target).closest('form')
    const assignmentMap = JSON.parse($('#assignment-map')[0].dataset.assignmentMap)
    const personReactSelect = $(form).find('[name$="person_id]"]').closest('[data-react-class]')[0]
    if (!personReactSelect)
      return

    const currentProps = JSON.parse(personReactSelect.dataset.reactProps)
    const filteredPeople = []
    const {roleId, circleId} = getRoleAndCircleId(event, fieldName, form)

    assignmentMap.forEach((person) => {
      if (person.roles.includes(roleId) && (!circleId || person.circles.includes(circleId)))
        filteredPeople.push({label: person.name, value: person.id, imageData: {image: person.image}})
    })
    currentProps.options = filteredPeople
    personReactSelect.dataset.reactProps = JSON.stringify(currentProps)
  }, 50)
}

function getRoleAndCircleId(event, fieldName, form) {
  const fieldElement = $(form).find(`[name$="${fieldName}]"]`)[0]

  if (!fieldElement || fieldElement.value === '')
    return {}

  const fieldValue = fieldElement.value

  if (fieldName && fieldName === 'role_id')
    return {roleId: parseInt(fieldValue, 10) || -1}
  if (fieldName === 'role_id_circle_id') {
    const [roleId, circleId] = fieldValue.split(',').map((id) => parseInt(id, 10) || -1)
    return {roleId, circleId}
  }
  return {}
}

function setModified(event) {
  const $form = $(event.target).closest('form')
  $form.data('modified', true)
}

function queueSubmit(event, timeout = 30) {
  const $form = $(event.target).closest('form')
  const queuedFn = setTimeout(() => {
    if ($form.data('modified'))
      $form[0].requestSubmit()
  }, timeout)
  $form.data('timeout', queuedFn)
}

function dequeueSubmit(event) {
  const $form = $(event.target).closest('form')
  window.clearTimeout($form.data('timeout'))
  $form.data('timeout', null)
}

function setupRolePersonDropdown(formId, fieldName = 'role_id') {
  setTimeout(() => {
    const $form = $(`#${formId}`)
    $form.on('change', 'div.js-slick-update-person', (e) => {
      if ($(e.target).hasClass('js-slick-update-person'))
        updatePersonDropdown(e, fieldName)
    })

    // Initialize the person dropdown based on the initial value of the fieldName dropdown
    const initialEvent = {target: $form.find(`[name$="${fieldName}]"]`)[0]}
    updatePersonDropdown(initialEvent, fieldName)
  }, 50)
}
// setupSaveOnFormBlur
function setupSlickForms() {
  // debug...
  setTimeout(() => {
    $('body').on(
      'change',
      'form.slick-form input, form.slick-form textarea, form.slick-form select, form.slick-form div.js-slick-auto-save',
      setModified,
    )
    $('body').on(
      'blur',
      'form.slick-form input, form.slick-form textarea, form.slick-form select',
      queueSubmit,
    )
    $('body').on(
      'focus',
      'form.slick-form input, form.slick-form textarea, form.slick-form select',
      dequeueSubmit,
    )
  }, 100)
}

export default
{animate,
  archiveAll,
  closeBsModal,
  enableBsPopovers,
  enableReordering,
  refreshTurboFrame,
  setupRolePersonDropdown,
  setupSlickForms}
